
import { ReactNode } from 'react';
// import Button from 'react-bootstrap/Button';
import { Modal, ModalProps } from 'react-bootstrap';
import { Conten, ButtonBack, ButtonConfirm } from './styles';

interface MyModalProps extends ModalProps {
    show: boolean;
    content: string | ReactNode;
    onClose: () => void;
    onCloseX: () => void;
}

export function ModalValidTerm({ show, content, confirmButtonText, onClose, onCloseX, confirmMethod }: MyModalProps) {
    return (
        <>
            <Modal
                show={show}
                onHide={onCloseX}
                animation={false}
                backdrop="static"
                keyboard={false}
                aria-labelledby="example-custom-modal-styling-title"
                className='modalNovo'
                size='xl'
            >
                <Conten>
                    <Modal.Header closeButton className="modal-header">
                        <span>Atenção</span>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        {content}
                    </Modal.Body>
                    <Modal.Footer className="modal-footer">
                        <ButtonBack onClick={onClose}>
                            Voltar
                        </ButtonBack>
                        {confirmMethod && (
                            <ButtonConfirm onClick={confirmMethod}>
                                {confirmButtonText}
                            </ButtonConfirm>
                        )}
                    </Modal.Footer>
                </Conten>
            </Modal>
        </>
    );
}
